import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';

function FinancialsPreview(props){
    const [registration, setRegistration] = useState(props.registration);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [financials, setFinancials] = useState(props.financials);
    const [expenditures, setExpenditures] = useState(props.expenditures);
    const [expectedResults, setExpectedResults] = useState(props.expectedResults);
    const [techAssistance, setTechAssistance] = useState(props.techAssistance);
    const [heardAbouts, setHeardAbouts] = useState(props.heardAbouts);
    const [dropdowns, setDropdowns] = useState(props.dropdowns);
    const [techOther, setTechOther] = useState(props.techOther);
    
    const curformat = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    let nums = 0;

    useEffect(() => {
        setRegistration(props.registration);
        setBusinessDetails(props.businessDetails);
        setFinancials(props.financials);
        setExpenditures(props.expenditures);
        setExpectedResults(props.expectedResults);
        setTechAssistance(props.techAssistance);
        setHeardAbouts(props.heardAbouts);
        setDropdowns(props.dropdowns);
    },[]);

    const formatDropdown = (cell, field) => {
        if(field == 'regions'){
            let reg = (dropdowns[field] !== undefined) ? dropdowns[field].filter(rg => rg.code == cell) : [];
            return (reg[0]!==undefined) ? reg[0].name : cell;
        }else if(field == 'districts'){
            let dist = (dropdowns[field] !== undefined) ? dropdowns[field].filter(dt => dt.id == cell) : [];
            return (dist[0]!==undefined) ? dist[0].name : cell;
        }else{
            let drop = (dropdowns[field] !== undefined) ? dropdowns[field].filter(dd => dd.ivalue == cell) : [];
            return (drop[0] !== undefined) ? drop[0].iname : cell;
        }
    }

    return(
        <div className="row preview">
             <div className="col-12">
           <br /><hr /><h5>Financial <span>Details</span><button className="btn text-primary" onClick={() => props.editForm(5)}><FontAwesomeIcon icon={faEdit} size="sm" /></button></h5>
           </div>
            <div className="col-12">
                <ul>
                    {/* <li>Did your business try/apply to raise capital in 2020? <span>{formatDropdown(financials.loan_attempt,'raised_capital')} </span></li>
                    {financials.loan_attempt != 4 && <li>Was the raising of the capital successful? <span>{formatDropdown(financials.attempt_status,'capital_status')} </span></li>} */}
                    <li>Requested Grant Amount (GHS):<span>{curformat.format(financials.getp3requested_amt)} </span></li>
                    <li>Benefited from any grant program?<span>{financials.isrecievedgrantbefore==1 ? 'Yes' : 'No'} </span></li>
                    {/* <li>Have you defaulted in servicing the credit facilities?:<span>{financials.loan_default==1?'Yes':'No'} </span></li> */}
                </ul>
            </div>
           
            <div className="col-12">
                <ul>
                    
                    {financials.isrecievedgrantbefore==1 && <><li>Bank Name:<span>{financials.grantawardingorg}</span></li>
                    <li>Account Name:<span>{financials.awardamount}</span></li>
                    <li>Account Number:<span>{financials.awardyear}</span></li></>}
                    
                   
                </ul>
            </div>
            
           <div className="col-12">
                <hr /><h5>Expected Grants <span>Expenditure</span><button className="btn text-primary" onClick={() => props.editForm(6)}><FontAwesomeIcon icon={faEdit} size="sm" /></button></h5>
                <table className="table table-bordered table-striped table-condensed">
                    <thead>
                        <th scope="col">No.</th>
                        <th scope="col" style={{width:'40%'}}>Item</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Unit Cost (GHS)</th>
                        <th scope="col">Amount</th>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1.</th>
                            <td>{formatDropdown(expenditures[0].item,'expenditure')}</td>
                            <td>{expenditures[0].quantity}</td>
                            <td>{curformat.format(expenditures[0].unitcost)}</td>
                            <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[0].amount)}</td>
                        </tr>
                        <tr>
                            <th scope="row">2.</th>
                            <td>{formatDropdown(expenditures[1].item,'expenditure')}</td>
                            <td>{expenditures[1].quantity}</td>
                            <td>{curformat.format(expenditures[1].unitcost)}</td>
                            <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[1].amount)}</td>
                        </tr>
                        <tr>
                            <th scope="row">3.</th>
                            <td>{formatDropdown(expenditures[2].item,'expenditure')}</td>
                            <td>{expenditures[2].quantity}</td>
                            <td>{curformat.format(expenditures[2].unitcost)}</td>
                            <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[2].amount)}</td>
                        </tr>
                        {expenditures.map((exp, idx) => {
                                    if(idx >= 3){
                                    return(
                                <tr>
                                <th scope="row">{(idx + 1)}.</th>
                                <td>{expenditures[idx].item_other}</td>
                                <td>{expenditures[idx].quantity}</td>
                                <td>{expenditures[idx].unitcost}</td>
                                <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[idx].amount)}</td>
                            </tr>
                                    )}})}
                        <tr>
                            <th scope="row"></th>
                            <th>Total Expected Expenditure</th>
                            <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.quantity)))}</th>
                            <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.unitcost)))}</th>
                            <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.amount)))}</th>
                        </tr>
            
                    </tbody>
                </table>
            </div>
            
            <div className="col-12">
            <>
                <hr /><h5>Technical Assistance <span>Needs</span><button className="btn text-primary" onClick={() => props.editForm(7)}><FontAwesomeIcon icon={faEdit} size="sm" /></button></h5>
                <div className=""><b>Do you need Business Development Services? {businessDetails.tech_assistance ==0 ? 'No' : 'Yes'}</b></div>
                <ol>
                {dropdowns.development!==undefined && dropdowns.development.map(dev => {
                    if(techAssistance.includes(parseInt(dev.ivalue))){
                        return <li>{dev.iname} {(dev.ivalue == '11')?`: ${techOther.development}`:''}</li>
                    }
                })}
                </ol></>

                <div className="mt-5"><b>How did you hear about the SME High-Growth Programme Response Grants?</b></div>
                <ol>
                {dropdowns.heard_about!==undefined && dropdowns.heard_about.map(habout => {
                    if(heardAbouts.includes(parseInt(habout.ivalue))){
                        return <li>{habout.iname} {(habout.ivalue == '12')?`: ${techOther.heardAbout}`:''}</li>
                    }
                })}
                </ol>
            </div>
        </div>
    );
}

export default FinancialsPreview;